import { AutoComplete, Form } from "antd";
import { useState } from "react";
import debounce from "lodash.debounce";

const LocationAutoComplete = ({
  form,
  locationList,
  handleAddressPlaceSelect,
  fieldName,
  label,
  width= "262px",
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const fetchGooglePlaces = debounce((input) => {
    if (!input) return;

    const service = new window.google.maps.places.AutocompleteService();
    service.getPlacePredictions({ input }, (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        setOptions(
          predictions.map((prediction) => ({
            label: prediction?.description,
            source: "google",
          }))
        );
      }
    });
  }, 300);

  const handleSearch = (input) => {
    setInputValue(input);

    if (!input) {
      setOptions([]);
      return;
    }

    const localMatches = locationList
      .filter((location) =>
        location.name.toLowerCase().includes(input.toLowerCase())
      )
      .map((location) => ({
        label: location.name,
        value: location.id,
        source: "api",
      }));

    if (localMatches.length > 0) {
      setOptions(localMatches);
    } else {
      fetchGooglePlaces(input);
    }
  };

  const handleSelect = (value, option) => {
    setInputValue(option.label);

    if (option.source === "api") {
      const selectedLocation = locationList.find(
        (loc) => loc.id === option.keyId
      );
      if (selectedLocation) {
        handleAddressPlaceSelect(selectedLocation);
      }
    } else if (option.source === "google") {
      handleAddressPlaceSelect({ name: option.label, id: value }, fieldName);
    }
  };

  return (
    <Form.Item
      label={label}
      name={fieldName}
      style={{ marginBottom: "16px", width: width, marginLeft: "6px" }}
    >
      <AutoComplete
        style={{
          width: "100%",
          boxShadow: "none",
          height: "36px",
          backgroundColor: "#F3F3F3",
          color: "#5E5E5E",
          borderRadius: "8px",
        }}
        options={options.map((option) => ({
          label: option.label,
          value: option.label,
          source: option.source,
          keyId: option.value,
        }))}
        value={inputValue}
        onSearch={handleSearch}
        onSelect={(value, option) => handleSelect(option.keyId, option)}
        onChange={setInputValue}
        placeholder={`Select ${label}`}
        der
      />
    </Form.Item>
  );
};

export default LocationAutoComplete;
